import React, { useState, useEffect } from 'react';
import {
  Row, Col, ButtonGroup, Dropdown, DropdownButton,
} from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import ExternalLink from 'components/Widgets/ExternalLink';

import { useNavigate } from 'react-router-dom';
import Actions from 'components/Members/Schedule/Actions';
import Card from './Card';

export default function NextSessions() {
  const [sessions, setSessions] = useState(null);

  const navigate = useNavigate();

  const dateFormat = (value) => {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    const options = { month: 'long', day: 'numeric' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  const onConfirmClick = (stepId) => {
    Actions.confirmSession(stepId, (data) => {
      setSessions((prev) => prev.map((item) => (item.id === data.id ? data : item)));
    });
  };

  useEffect(() => {
    axios
      .get(routes.api.members.schedule.nextSessions)
      .then((resp) => {
        setSessions(resp.data.data);
      });
  }, []);

  if (sessions === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="mb-3 mb-sm-5" />
    );
  }

  return (
    <>
      {sessions.length === 0 ? (
        <p className="mb-3 mb-sm-5">
          Welcome to your schedule!
          {' '}
          You will be able to find all information about your scheduled and past sessions here.
        </p>
      ) : (
        <>
          <section className="d-flex align-items-start mb-3">
            <h4>Upcoming Sessions</h4>

            <small className="ms-2 px-1 bg-secondary-50 text-secondary rounded">
              {dateFormat(sessions[0].attributes.start_at)}
            </small>
          </section>

          <Row className="mb-3 mb-sm-4">
            {sessions.map((session, index) => (
              <Col key={session.id} lg={6} className="mb-4">
                <Card record={session} nextSession={index === 0}  >
                  <>
                    <ButtonGroup>
                      <DropdownButton
                        as={ButtonGroup}
                        variant="outline-primary"
                        title="More"
                      >
                        <Dropdown.Item
                          eventKey={`session-card-${session.id}-reschedule`}
                          href={routes.members.steps.schedule(session.attributes.step.id)}
                        >
                          Reschedule and Cancel
                        </Dropdown.Item>

                        {session.attributes.possible_confirm && (
                          <Dropdown.Item
                            eventKey={`session-card-${session.id}-confirm`}
                            onClick={() => onConfirmClick(session.attributes.step.id)}
                          >
                            Confirm
                          </Dropdown.Item>
                        )}

                        <Dropdown.Item
                          eventKey={`session-card-${session.id}-add-to-calendar`}
                          href={routes.api.steps.session.generateIcs(session.attributes.step.id)}
                        >
                          Add to Calendar
                        </Dropdown.Item>

                        <Dropdown.Item
                          eventKey={`session-card-${session.id}-meeting-link`}
                          onClick={() => {
                            navigate(routes.members.steps.zoomInfo(session.attributes.step.id));
                          }}
                        >
                          Meeting Link
                        </Dropdown.Item>

                        <Dropdown.Item
                          eventKey={`session-card-${session.id}-program-page`}
                          href={routes.members.programs.show(session.attributes.program.id)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Program
                        </Dropdown.Item>

                        <Dropdown.Item
                          eventKey={`session-card-${session.id}-chat-page`}
                          href={routes.members.chats.messages(session.attributes.program.chat_id)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Chat
                        </Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>

                    <ExternalLink
                      href={session.attributes.zoom_link}
                      className="ms-3"
                    >
                      Join
                    </ExternalLink>
                  </>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  );
}
